import { render } from "./EditingElement.vue?vue&type=template&id=c9aff10a"
import script from "./EditingElement.vue?vue&type=script&lang=js"
export * from "./EditingElement.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__